<template>
  <label
    :for="`input${uid}`"
    :class="{ [sizeClasses[size]]: true, 'cursor-not-allowed!': disabled }"
    class="rf-checkbox--container text-action-buttons text-grey-1 flex cursor-pointer select-none"
  >
    <input
      :id="`input${uid}`"
      v-model="model"
      type="checkbox"
      :disabled="disabled"
      class="rf-checkbox--input"
    />
    <span class="rf-checkbox--visual relative box-border inline-block shrink-0" aria-hidden="true">
      <span
        class="after:border-white-1 rf-checkbox--visual-checkmark absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded opacity-100 after:absolute after:hidden after:border-solid"
        aria-hidden="true"
        :class="[
          intermediate ? 'rf-checkbox--intermediate' : 'rf-checkbox--checkmark',
          disabled ? 'shadow-none!' : '',
        ]"
      ></span>
    </span>

    <span
      v-if="!!$slots.default"
      :class="{
        'mt-2 ml-1 box-border grow text-start': !!$slots.default,
        'mt-0! pl-2.5': size === 'small',
      }"
    >
      <slot></slot>
    </span>
  </label>
</template>

<script>
const sizeClasses = {
  small:
    "rf-checkbox--sm [&_.rf-checkbox--visual]:h-4.5 [&_.rf-checkbox--visual]:w-4.5 [&_.rf-checkbox--visual-checkmark]:h-4.5 [&_.rf-checkbox--visual-checkmark]:w-4.5 items-center",
  base: "rf-checkbox--base [&_.rf-checkbox--visual]:h-10 [&_.rf-checkbox--visual]:w-10 [&_.rf-checkbox--visual-checkmark]:h-4.5 [&_.rf-checkbox--visual-checkmark]:w-4.5 items-start",
};
</script>
<script setup>
import { getCurrentInstance } from "vue";

const { uid } = getCurrentInstance();
const model = defineModel({ type: Boolean, default: false });

defineProps({
  intermediate: { type: Boolean, default: false },
  size: {
    type: String,
    default: "base",
    validator: value => Object.keys(sizeClasses).includes(value),
  },
  disabled: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.rf-checkbox--container {
  &.rf-checkbox--sm .rf-checkbox--checkmark::after {
    left: 6px;
    top: 2.5px;
    width: 5.5px;
    height: 10px;
    border-width: 0 1.5px 1.5px 0;
  }

  &.rf-checkbox--base .rf-checkbox--visual-checkmark::after {
    height: 10px;
  }
  &.rf-checkbox--base .rf-checkbox--intermediate::after {
    left: 4px;
    top: 0px;
    width: 10px;
    border-width: 0 0 1.5px 0;
  }
  &.rf-checkbox--base .rf-checkbox--checkmark::after {
    left: 6px;
    top: 2.5px;
    width: 5.5px;
    border-width: 0 1.5px 1.5px 0;
  }
}
.rf-checkbox {
  &--container:hover .rf-checkbox--visual-checkmark {
    box-shadow: 0px 4px 12px rgba(92, 104, 124, 0.16);
  }

  &--checkmark {
    &::after {
      content: "";
      transform: rotate(45deg);
    }
  }

  &--input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ span .rf-checkbox--visual-checkmark {
      background-color: var(--color-blue-50);
      &::after {
        display: block;
      }
    }

    &:not(:checked) ~ span .rf-checkbox--visual-checkmark {
      border: 2px solid var(--color-beige-20);
      background-color: var(--color-white-1);
    }

    &:focus-visible ~ span .rf-checkbox--visual-checkmark {
      box-shadow: 0px 4px 12px rgba(92, 104, 124, 0.16);
    }
  }
}
</style>
